import { ProtectedRoute } from '@/components/auth/protected-route.js';
import { DashboardPage } from '@/features/dashboards/components/dashboard-page.js';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// ---------------------------------------------------------------------------
// URL search schema — F5: global_params + widget_params persisted to URL
// ---------------------------------------------------------------------------
//
// F-1 (deferred): URL state is currently READ-ONLY. The dashboard reads global_params
// and widget_params from the URL on mount and uses them as the initial execution params.
// Full bidirectional sync — where in-page param changes also update the URL — requires a
// params form component (similar to the report execute page's ParamsForm) that is out of
// scope for hito 4.5. This is tracked as a follow-up item for a future hito.

const DashboardSearchSchema = z.object({
  global_params: z.record(z.unknown()).optional().catch(undefined),
  widget_params: z.record(z.record(z.unknown())).optional().catch(undefined),
});

export const Route = createFileRoute('/dashboards/$id')({
  validateSearch: DashboardSearchSchema,
  component: DashboardRoute,
});

function DashboardRoute() {
  const { id } = Route.useParams();
  const { global_params, widget_params } = Route.useSearch();

  return (
    <ProtectedRoute>
      <DashboardPage
        tenantReportId={id}
        globalParams={global_params ?? {}}
        widgetParamsMap={widget_params ?? {}}
      />
    </ProtectedRoute>
  );
}
